<template>
       <div class="box-card" >
        <div style="background-color: #fff;padding: 10px">
         <div style="display: flex;justify-content: space-between">
           <div style="width: 29%">
           <el-date-picker
            v-model="year"
            type="year"
            placeholder="选择年"
            size="mini"
        style="width: 88px">
        </el-date-picker><span style="font-size: 12px">年</span>
           </div>
           <div style="width: 36%">
            <span style="margin-left: -6px;" class="txx">销售代表</span>
            <el-select v-model="owner_id" placeholder="请选择" style="width:78px" size="mini">
              <el-option></el-option>
            </el-select>
           </div>
           <div style="width: 32%">
          <span class="txx">完成情况</span>
          <el-select v-model="complete" placeholder="请选择" style="width: 58px" size="mini" class="inputSty3">
            <el-option label="已完成" value="T"></el-option>
            <el-option label="未完成" value="F"></el-option>
            <el-option label="全部" value=""></el-option>
          </el-select>
           </div>
         </div>
          <div style="margin-top: 5px;display: flex;justify-content: space-between;align-items: center">
            <span class="txx">项目名称</span>
            <el-select v-model="project_id" placeholder="请选择" style="width:238px" size="mini">
              <el-option></el-option>
            </el-select>
            <button type="warning" size="mini" @click="" style="background-color: #ff9901;border: 1px solid #ff9901;color: #fff;border-radius: 4px">查询</button>
          </div>
        </div>
         <el-scrollbar style="height: 100%;background-color: #fff;margin-top:10px;padding: 10px">
           <div style="height: auto">
                     <el-row>
                       <el-col :span="1"><div class="grid-content bg-purple">
                         <img src="./../../assets/images/mu.png" class="im">
                       </div></el-col>
                       <el-col :span="23"><div class="grid-content bg-purple-light" style="padding-left: 5px">
                         <span class="t">销售金额</span>
                       <div class="l1">
                         <el-row :gutter="20">
                           <el-col :span="6"><div class="grid-content bg-purple">
                             <p class="txs">时间段</p>
                             <p class="txs"  v-for="item in Amounts1">
                               {{item}}
                             </p>
                             <p class="txs">汇总</p>
                           </div></el-col>
                           <el-col :span="6"><div class="grid-content bg-purple">
                             <p class="txs">考核指标</p>
                             <p class="txs"  v-for="item in Amounts">{{item.target_value}}</p>
                             <p class="txs">{{Amount}}</p>
                           </div></el-col>
                           <el-col :span="6"><div class="grid-content bg-purple">
                             <p class="txs">指标完成</p>
                             <p class="txs"  v-for="item in Amounts">{{item.actual_value }}</p>
                             <p class="txs">{{Amount1}}</p>
                           </div></el-col>
                           <el-col :span="6"><div class="grid-content bg-purple">
                             <p class="txs">完成率</p>
                             <div v-for="item in Amounts">
                               <p v-if="item.rate=='100'" style="color:#7ED321" class="txs">
                                 {{item.rate+'%'}}
                               </p>
                               <p v-else style="color: red" class="txs">
                                 {{item.rate+'%'}}
                               </p>
                             </div>
                             <p v-if="Amount2=='100.0'" style="color:#7ED321" class="txs">
                               {{Amount2+'%'}}
                             </p>
                             <p v-else style="color: red" class="txs">
                               {{Amount2+'%'}}
                             </p>
                           </div></el-col>
                         </el-row>
                       </div>
                     </div></el-col>
                     </el-row>
                     <div class="dv">
                       <el-divider></el-divider>
                     </div>
                     <el-row>
                       <el-col :span="1"><div class="grid-content bg-purple">
                         <img src="./../../assets/images/mu.png" class="im">
                       </div></el-col>
                       <el-col :span="23"><div class="grid-content bg-purple-light" style="padding-left: 5px">
                         <span class="t">考核毛利率</span>
                         <div class="l1">
                           <el-row :gutter="20">
                             <el-col :span="6"><div class="grid-content bg-purple">
                               <p class="txs">时间段</p>
                               <p class="txs" v-for="item in Assessment1">
                                 {{item}}
                               </p>
                               <p class="txs">汇总</p>
                             </div></el-col>
                             <el-col :span="6"><div class="grid-content bg-purple">
                               <p class="txs">考核指标</p>
                               <p class="txs" v-for="item in Assessment">{{item.target_value}}</p>
                               <p class="txs">{{Assess}}</p>
                             </div></el-col>
                             <el-col :span="6"><div class="grid-content bg-purple">
                               <p class="txs">指标完成</p>
                               <p class="txs" v-for="item in Assessment">{{item.actual_value}}</p>
                               <p class="txs">{{Assess1}}</p>
                             </div></el-col>
                             <el-col :span="6"><div class="grid-content bg-purple">
                               <p class="txs">完成率</p>
                               <div v-for="item in Assessment">
                                 <p v-if="item.rate=='100'" style="color:#7ED321" class="txs">
                                   {{item.rate+'%'}}
                                 </p>
                                 <p v-else style="color: red" class="txs">
                                   {{item.rate+'%'}}
                                 </p>
                                 <div v-for="item in Assessment">
                                   <p v-if="item.cycle=='QUARTER' && item.kpi_type=='SKU'" @click="xt(item)" style="position: absolute;margin-top: -26px;margin-left: 60px" class="el-icon-arrow-right"></p>
                                   <p v-else></p>
                                 </div>

                               </div>
                               <div>
                                 <p v-if="Assess2=='100.0'" style="color:#7ED321" class="txs">
                                   {{Assess2+'%'}}
                                 </p>
                                 <p v-else style="color: red" class="txs">
                                   {{Assess2+'%'}}
                                 </p>
             <!--                    <div v-for="item in Assessment">-->
             <!--                      <p v-if="item.cycle=='QUARTER' && item.kpi_type=='SKU'" @click="xt()" style="position: absolute;margin-top: -26px;margin-left: 60px" class="el-icon-arrow-right"></p>-->
             <!--                      <p v-else></p>-->
             <!--                    </div>-->
                               </div>

                             </div></el-col>
                           </el-row>
                         </div>
                       </div></el-col>
                     </el-row>


                     <div class="dv">
                       <el-divider></el-divider>
                     </div>
                     <el-row>
                       <el-col :span="1"><div class="grid-content bg-purple">
                         <img src="./../../assets/images/mu.png" class="im">
                       </div></el-col>
                       <el-col :span="23"><div class="grid-content bg-purple-light" style="padding-left: 5px">
                         <span class="t">动销客户数</span>
                         <div class="l1">
                           <el-row :gutter="20">
                             <el-col :span="6"><div class="grid-content bg-purple">
                               <p class="txs">时间段</p>
                               <p class="txs" v-for="item in ItemSold1">
                                 {{item}}
                               </p>
                               <p class="txs">汇总</p>
                             </div></el-col>
                             <el-col :span="6"><div class="grid-content bg-purple">
                               <p class="txs">考核指标</p>
                               <p class="txs" v-for="item in ItemSold">{{item.target_value}}</p>
                               <p class="txs">{{Item}}</p>
                             </div></el-col>
                             <el-col :span="6"><div class="grid-content bg-purple">
                               <p class="txs">指标完成</p>
                               <p class="txs" v-for="item in ItemSold">{{item.actual_value}}</p>
                               <p class="txs">{{Item1}}</p>
                             </div></el-col>
                             <el-col :span="6"><div class="grid-content bg-purple">
                               <p class="txs">完成率</p>
                               <div v-for="item in ItemSold">
                                 <p v-if="item.rate>'100.00'" style="color:red" class="txs">
                                   {{item.rate+'%'}}
                                 </p>
                                 <p v-else style="color: #7ED321" class="txs">
                                   {{item.rate+'%'}}
                                 </p>
                               </div>
                               <p v-if="Item2!='100.0'" style="color:red" class="txs">
                                 {{Item2+'%'}}
                               </p>
                               <p v-else style="color: #7ED321" class="txs">
                                 {{Item2+'%'}}
                               </p>
                             </div></el-col>
                           </el-row>
                         </div>
                       </div></el-col>
                     </el-row>

                     <div class="dv">
                       <el-divider></el-divider>
                     </div>
                     <el-row>
                       <el-col :span="1"><div class="grid-content bg-purple">
                         <img src="./../../assets/images/mu.png" class="im">
                       </div></el-col>
                       <el-col :span="23"><div class="grid-content bg-purple-light" style="padding-left: 5px">
                         <span class="t">单品销售数量</span>
                         <div class="l1">
                           <el-row :gutter="20">
                             <el-col :span="6"><div class="grid-content bg-purple">
                               <p class="txs">时间段</p>
                               <p class="txs" v-for="item in PinCustomer1">
                                 {{item}}
                               </p>
                               <p class="txs">汇总</p>
                             </div></el-col>
                             <el-col :span="6"><div class="grid-content bg-purple">
                               <p class="txs">考核指标</p>
                               <p class="txs" v-for="item in PinCustomer">{{item.target_value}}</p>
                               <p class="txs">{{Customer}}</p>
                             </div></el-col>
                             <el-col :span="6"><div class="grid-content bg-purple">
                               <p class="txs">指标完成</p>
                               <p class="txs" v-for="item in PinCustomer">{{item.actual_value }}</p>
                               <p class="txs">{{Customer1}}</p>
                             </div></el-col>
                             <el-col :span="6"><div class="grid-content bg-purple">
                               <p class="txs">完成率</p>
                               <div v-for="item in PinCustomer">
                                 <p v-if="item.rate!='100'" style="color:red" class="txs">
                                   {{item.rate+'%'}}
                                 </p>
                                 <p v-else style="color: #7ED321" class="txs">
                                   {{item.rate+'%'}}
                                 </p>
                                 <p @click="xt(item)" style="position: absolute;margin-top: -26px;margin-left: 60px" class="el-icon-arrow-right"></p>
                               </div>
                               <div>
                                 <p v-if="Customer2!='100.0'" style="color:red" class="txs">
                                   {{Customer2+'%'}}
                                 </p>
                                 <p v-else style="color: #7ED321" class="txs">
                                   {{Customer2+'%'}}
                                 </p>
<!--                                 <p @click="xt()" style="position: absolute;margin-top: -26px;margin-left: 60px" class="el-icon-arrow-right"></p>-->
                               </div>

                             </div></el-col>
                           </el-row>
                         </div>
                       </div></el-col>
                     </el-row>


                     <div class="dv">
                       <el-divider></el-divider>
                     </div>
                     <el-row>
                       <el-col :span="1"><div class="grid-content bg-purple">
                         <img src="./../../assets/images/mu.png" class="im">
                       </div></el-col>
                       <el-col :span="23"><div class="grid-content bg-purple-light" style="padding-left: 5px">
                         <span class="t">客户拜访数量</span>
                         <div class="l1">
                           <el-row :gutter="20">
                             <el-col :span="6"><div class="grid-content bg-purple">
                               <p class="txs">时间段</p>
                               <p class="txs" v-for="item in visits1">
                                 {{item}}
                               </p>
                               <p class="txs">汇总</p>
                             </div></el-col>
                             <el-col :span="6"><div class="grid-content bg-purple">
                               <p class="txs">考核指标</p>
                               <p class="txs" v-for="item in visits">{{item.target_value}}</p>
                               <p class="txs">{{visit}}</p>
                             </div></el-col>
                             <el-col :span="6"><div class="grid-content bg-purple">
                               <p class="txs">指标完成</p>
                               <p class="txs" v-for="item in visits">{{item.actual_value}}</p>
                               <p class="txs">{{visit1}}</p>
                             </div></el-col>
                             <el-col :span="6"><div class="grid-content bg-purple">
                               <p class="txs">完成率</p>
                               <div v-for="item in visits">
                                 <p v-if="item.rate>'100.00'" style="color:red" class="txs">
                                   {{item.rate+'%'}}
                                 </p>
                                 <p v-else style="color: #7ED321" class="txs">
                                   {{item.rate+'%'}}
                                 </p>
                               </div>
                               <p v-if="visit2!='100.0'" style="color:red" class="txs">
                                 {{visit2+'%'}}
                               </p>
                               <p v-else style="color: #7ED321" class="txs">
                                 {{visit2+'%'}}
                               </p>
                             </div></el-col>
                           </el-row>
                         </div>
                       </div></el-col>
                     </el-row>


                     <div class="dv">
                       <el-divider></el-divider>
                     </div>
                     <el-row>
                       <el-col :span="1"><div class="grid-content bg-purple">
                         <img src="./../../assets/images/mu.png" class="im">
                       </div></el-col>
                       <el-col :span="23"><div class="grid-content bg-purple-light" style="padding-left: 5px">
                         <span class="t">新增门店数</span>
                         <div class="l1">
                           <el-row :gutter="20">
                             <el-col :span="6"><div class="grid-content bg-purple">
                               <p class="txs">时间段</p>
                               <p class="txs" v-for="item in stores1">
                                 {{item}}
                               </p>
                               <p class="txs">汇总</p>
                             </div></el-col>
                             <el-col :span="6"><div class="grid-content bg-purple">
                               <p class="txs">考核指标</p>
                               <p class="txs" v-for="item in stores">{{item.target_value}}</p>
                               <p class="txs">{{store}}</p>
                             </div></el-col>
                             <el-col :span="6"><div class="grid-content bg-purple">
                               <p class="txs">指标完成</p>
                               <p class="txs" v-for="item in stores">{{item.actual_value}}</p>
                               <p class="txs">{{store1}}</p>
                             </div></el-col>
                             <el-col :span="6"><div class="grid-content bg-purple">
                               <p class="txs">完成率</p>
                               <div v-for="item in stores">
                                 <p v-if="item.rate>'100.00'" style="color:red" class="txs">
                                   {{item.rate+'%'}}
                                 </p>
                                 <p v-else style="color: #7ED321" class="txs">
                                   {{item.rate+'%'}}
                                 </p>
                               </div>
                               <p v-if="store2!='100.0'" style="color:red" class="txs">
                                 {{store2+'%'}}
                               </p>
                               <p v-else style="color: #7ED321" class="txs">
                                 {{store2+'%'}}
                               </p>
                             </div></el-col>
                           </el-row>
                         </div>
                       </div></el-col>
                     </el-row>


                     <div class="dv">
                       <el-divider></el-divider>
                     </div>
                     <el-row>
                       <el-col :span="1"><div class="grid-content bg-purple">
                         <img src="./../../assets/images/mu.png" class="im">
                       </div></el-col>
                       <el-col :span="23"><div class="grid-content bg-purple-light" style="padding-left: 5px">
                         <span class="t">门店上架品规数</span>
                         <div class="l1">
                           <el-row :gutter="20">
                             <el-col :span="6"><div class="grid-content bg-purple">
                               <p class="txs">时间段</p>
                               <p class="txs" v-for="item in specifications1">
                                 {{item}}
                               </p>
                               <p class="txs">汇总</p>
                             </div></el-col>
                             <el-col :span="6"><div class="grid-content bg-purple">
                               <p class="txs">考核指标</p>
                               <p class="txs" v-for="item in specifications">{{item.target_value}}</p>
                               <p class="txs">{{specification}}</p>
                             </div></el-col>
                             <el-col :span="6"><div class="grid-content bg-purple">
                               <p class="txs">指标完成</p>
                               <p class="txs" v-for="item in specifications">{{item.actual_value}}</p>
                               <p class="txs">{{specification1}}</p>
                             </div></el-col>
                             <el-col :span="6"><div class="grid-content bg-purple">
                               <p class="txs">完成率</p>
                               <div v-for="item in specifications">
                                 <p v-if="item.rate>'100.00'" style="color:red" class="txs">
                                   {{item.rate+'%'}}
                                 </p>
                                 <p v-else style="color: #7ED321" class="txs">
                                   {{item.rate+'%'}}
                                 </p>
                               </div>
                               <p v-if="specification2!='100.0'" style="color:red" class="txs">
                                 {{specification2+'%'}}
                               </p>
                               <p v-else style="color: #7ED321" class="txs">
                                 {{specification2+'%'}}
                               </p>
                             </div></el-col>
                           </el-row>
                         </div>
                       </div></el-col>
                     </el-row>



           </div>
         </el-scrollbar>
     </div>

</template>

<script>
import navTars from "./navTars";
import http from '../../APIService/http'

export default {
  name: "Personal",
  components:{navTars},
  data(){
    return{
      navs:'个人指标完成情况',
      Assessment: [],  //考虑毛利率判断数组
      Assessment1: [],
      Assess: 0,
      Assess1: 0,
      Assess2: 0,
      Amounts: [],   //销售金额-数字
      Amounts1: [],  //销售金额-按时间段
      Amount: 0,
      Amount1: 0,
      Amount2: 0,
      ItemSold: [],      //动销客户
      ItemSold1: [],
      Item: 0,
      Item1: 0,
      Item2: 0,
      PinCustomer: [],  // 单品销售数量
      PinCustomer1: [],
      Customer: 0,
      Customer1: 0,
      Customer2: 0,
      visits: [],
      visits1: [],
      visit: 0,
      visit1: 0,
      visit2: 0,
      stores: [],  //新增门店数
      stores1: [],
      store: 0,
      store1: 0,
      store2: 0,
      specifications: [], //门店上架品规数
      specifications1: [],
      specification: 0,
      specification1: 0,
      specification2: 0,
      tenant_id: "1472813523",
      year: "2020",
      owner_id:"1231",
      complete:"",
      project_id:"sdfsadfa",

    }
  },
  methods:{
    xt(item){

      this.$router.push({path:'/Prout',query:{skuArr:item.skuArr}});
    },
    ns(){
      let that = this
      let forms={
        tenant_id: this.tenant_id,
        year: this.year,
        owner_id:this.owner_id,
        complete:this.complete,
        project_id:this.project_id,
      }

      http.post('/wapi/gkGetFeedback/GkAchievementOfPersonalTargets',forms).then(function (res){

        let name= res.data;
        let ats = name.SALES_AMOUNT;
        for(let i=0;i<ats.length;i++){
          for(let j=0;j<ats[i].array.length;j++){
            that.Amount += parseInt(ats[i].array[j].target_value);
            that.Amount1 += parseInt(ats[i].array[j].actual_value);
            that.Amount2= (that.Amount1/that.Amount).toFixed(3)* 100;
          }
          that.Amounts = ats[i].array;
          that.Amounts1.push(ats[i].title);
        }

        let asses = name.ASSESSMENT;
        for(let i=0;i<asses.length;i++){
          for(let j=0;j<asses[i].array.length;j++) {
            that.Assess += parseInt(asses[i].array[j].target_value);
            that.Assess1 += parseInt(asses[i].array[j].actual_value);
            that.Assess2 = (that.Assess1 / that.Assess).toFixed(3) * 100;
          }
          that.Assessment = asses[i].array;
          that.Assessment1.push(asses[i].title);
        }



        let item = name.SALES_CUSTOMERS;
        for(let i=0;i<item.length;i++){
          for(let j=0;j<item[i].array.length;j++){
            that.Item += parseInt(item[i].array[j].target_value);
            that.Item1 += parseInt(item[i].array[j].actual_value);
            that.Item2= (that.Item1/that.Item).toFixed(3)* 100;
          }
          that.ItemSold = item[i].array;
          that.ItemSold1.push(item[i].title);
        }

        let pinCust = name.UNIT_SALES_QUANTITY;
        for(let i=0;i<pinCust.length;i++){
          for(let j=0;j<pinCust[i].array.length;j++){
            that.Customer += parseInt(pinCust[i].array[j].target_value);
            that.Customer1 += parseInt(pinCust[i].array[j].actual_value);
            that.Customer2= (that.Customer1/that.Customer).toFixed(3)* 100;
          }
          that.PinCustomer = pinCust[i].array;
          that.PinCustomer1.push(pinCust[i].title);
        }

        let cust = name.CUSTOMER_VISITS;
        for(let i=0;i<cust.length;i++){
          for(let j=0;j<cust[i].array.length;j++){
            that.visit += parseInt(cust[i].array[j].target_value);
            that.visit1 += parseInt(cust[i].array[j].actual_value);
            that.visit2= (that.visit1/that.visit).toFixed(3)* 100;
          }
          that.visits = cust[i].array;
          that.visits1.push(cust[i].title);
        }

        let sto = name.NEW_STORES;
        for(let i=0;i<sto.length;i++){
          for(let j=0;j<sto[i].array.length;j++){
            that.store += parseInt(sto[i].array[j].target_value);
            that.store1 += parseInt(sto[i].array[j].actual_value);
            that.store2= (that.store1/that.store).toFixed(3)* 100;
          }
          that.stores = sto[i].array;
          that.stores1.push(sto[i].title);
        }

        let specif = name.PRODUCT_SPECIFICATIONS;
        for(let i=0;i<specif.length;i++){
          for(let j=0;j<specif[i].array.length;j++){
            that.specification += parseInt(specif[i].array[j].target_value);
            that.specification1 += parseInt(specif[i].array[j].actual_value);
            that.specification2= (that.specification1/that.specification).toFixed(3)* 100;
          }
          that.specifications = specif[i].array;
          that.specifications1.push(specif[i].title);
        }

      })
    }
  },
  created() {
    this.ns();
  }
}
</script>

<style >
    .headerCs >p{
        padding: 0;
        margin: 0;
    }
  .t{
    margin-left: 5px;
    font-size: 14px;
    color: #42505A;
  }
  .im{
    width: 14px;
    height: 14px;
  }
  .dv{
    margin-top: -15px;
    margin-bottom: -10px;
  }
  .el-card__body{
    padding: 5px;
  }
  .txx{
    font-size: 12px;
  }
  .txs{
    font-size: 13px;
    text-align: center;
  }
  button{
    border: 1px solid orange;
    color: white;
    background-color: orange;
    margin: 10px 5px;
  }

  .inputSty3 /deep/ .el-input__inner{
    background: white;
    color: black;
    text-align: center;
    padding: 0 7px 0px 2px;
  }
  .inputSty3 /deep/ .el-input--suffix .el-input__inner{
    padding-left: 0px;
  }
  .inputSty3 /deep/ span.el-input__suffix{
    right: -3px;

  }
  .el-input__icon el-icon-date {
    display: none;
  }
  .l1{
    color: #abacab;
    font-size: 13px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/gkReport/Personal.vue